/*=============================================== CardContainer ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import Variables from "./Variables";
/*==================== Component ====================*/
var CardContainer = function (_a) {
    var to = _a.to, children = _a.children, props = __rest(_a, ["to", "children"]);
    return (React.createElement(Container, __assign({ "$to": to, as: to ? Link : "div", to: to ? to : undefined }, props), children));
};
export default CardContainer;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    overflow: hidden;\n\n    ", "\n"], ["\n    width: 100%;\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    overflow: hidden;\n\n    ", "\n"])), Variables.Colors.Background, Variables.Radiuses.M, Variables.Shadows.M, function (_a) {
    var $to = _a.$to;
    return $to && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            color: currentColor;\n            text-decoration: none;\n            transition: ", ";\n\n            p {\n                font-weight: ", ";\n            }\n\n            @media ", " {\n                &:hover {\n                    transform: scale(1.02);\n                    box-shadow: ", ";\n                }\n            }\n        "], ["\n            color: currentColor;\n            text-decoration: none;\n            transition: ", ";\n\n            p {\n                font-weight: ", ";\n            }\n\n            @media ", " {\n                &:hover {\n                    transform: scale(1.02);\n                    box-shadow: ", ";\n                }\n            }\n        "])), Variables.Transitions.Short, Variables.FontWeights.Regular, Variables.Breakpoints.Hover, Variables.Shadows.XL);
});
var templateObject_1, templateObject_2;
